<mat-dialog-content>
  <p>Dziękujemy za okazane zaufanie. Możesz dalej bez przeszkód korzystać z Payki.</p>
  <p>Nowy regulamin zostanie przesłany na Twój adres e-mail.</p>
</mat-dialog-content>

<mat-dialog-actions align="start">
  <button (click)="close()" mat-button>Zamknij</button>
</mat-dialog-actions>
